import * as React from 'react'
import clx from 'classnames'

import { FaIcon, faIdBadgeRegular, faIdBadgeSolid } from '@/lib/fa'

export const DriverCell = ({
  name,
  className,
  customStyle,
  isActive = false,
}: {
  name: string
  className?: string
  customStyle?: any
  isActive?: boolean
}) => {
  return (
    <div
      className={clx('tw-flex tw-items-center tw-gap-1', className)}
      style={customStyle}
    >
      <span className="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-opacity-80">
        {isActive ? (
          <FaIcon icon={faIdBadgeSolid} className="tw-w-full" />
        ) : (
          <FaIcon icon={faIdBadgeRegular} className="tw-w-full" />
        )}
      </span>
      <span className={isActive ? 'tw-font-medium' : ''}>{name}</span>
    </div>
  )
}
